import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaArrowRight } from "react-icons/fa";
import BrandButton from "./BrandButton";
export const CTABanner = ({
  title,
  text,
  buttonLabel,
  to = "/contact",
  color = "#DB2777",
  hoverBg = "#fdf2f8",
}) => (
  <section className="px-6 md:px-12 lg:px-24 pb-20">
    <motion.div
      className="max-w-6xl mx-auto rounded-3xl px-6 py-12 md:px-12 text-center shadow-2xl"
      style={{ backgroundColor: color }}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <h2 className="font-display text-3xl md:text-4xl font-semibold text-white">
        {title}
      </h2>
      {text && (
        <p className="mx-auto mt-3 max-w-2xl text-lg text-white/90">{text}</p>
      )}
      <BrandButton
        as={Link}
        to={to}
        variant="secondary"
        className="mt-7"
        accent={{ base: color, hover: color, dark: color, soft: hoverBg, rgb: "15, 23, 42" }}
      >
        {buttonLabel}
      </BrandButton>
    </motion.div>
  </section>
);

export const StatsRow = ({ items, color = "#DB2777" }) => {
  const real = items.filter((s) => s.value && String(s.value).trim());
  if (real.length === 0) return null;

  return (
    <section className="px-6 md:px-12 lg:px-24 pb-8">
      <div
        className={`max-w-7xl mx-auto grid grid-cols-2 gap-4 ${
          real.length >= 4 ? "md:grid-cols-4" : real.length === 3 ? "md:grid-cols-3" : ""
        }`}
      >
        {real.map((s, i) => (
            <motion.div
                key={s.label}
                className="rounded-2xl border-t-4 bg-white p-6 text-center shadow-xl ring-1 ring-gray-900/5 transition-shadow duration-300 hover:shadow-2xl"
                style={{ borderTopColor: color }}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ y: -4 }}
                transition={{ duration: 0.5, ease: "easeOut", delay: i * 0.15 }}
                viewport={{ once: true }}
            >
                <p
                className="font-display text-3xl md:text-4xl font-bold"
                style={{ color }}
                >
                {s.value}
                </p>
                <p className="mt-1 text-sm text-slate-600">{s.label}</p>
            </motion.div>
            ))}
      </div>
    </section>
  );
};